import { Injectable } from '@angular/core';

import { FormFactory } from "@magieno/angular-advanced-forms";
import {
  ClientQuestionnaireResultBaseFactory,
} from '../../../base-client-questionnaire/form/base-result/client-questionnaire-result-base.factory';
import {
  MainSpouseQuebec2022TaxQuestionnaireOptions,
} from '../../../../../../../../../../common/src/options/client-questionnaire/quebec-2022-tax-questionnaire/main-spouse-quebec-2022-tax-questionnaire.options';

@Injectable()
export class Quebec2023TaxFormResultFactory extends ClientQuestionnaireResultBaseFactory {

  constructor(protected readonly formFactory: FormFactory) {
    super(formFactory);
    this.optionsType = MainSpouseQuebec2022TaxQuestionnaireOptions;
  }
}
